import { APIProvider, Map, MapCameraChangedEvent, MapEvent } from '@vis.gl/react-google-maps'
import React from 'react'

export interface MapWrapperProps {
  children: React.ReactNode
  center?: google.maps.LatLngLiteral | undefined
  defaultZoom?: number
  mapCenterChanged?: (event: MapCameraChangedEvent) => void
  onDragStart?: (event: MapEvent) => void
  onDragEnd?: (event: MapEvent) => void
  onZoomChanged?: (event: MapCameraChangedEvent) => void
  minZoom?: number | null
}

const MapWrapper: React.FC<MapWrapperProps> = ({
  children,
  center,
  defaultZoom,
  mapCenterChanged,
  onDragStart,
  onDragEnd,
  onZoomChanged,
  minZoom,
}) => (
  <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY || ''} libraries={['marker', 'places']}>
    <Map
      mapId={'watersport-google-map'}
      gestureHandling={'greedy'}
      defaultZoom={defaultZoom}
      defaultCenter={center}
      disableDefaultUI
      zoomControl={false}
      minZoom={minZoom}
      onCenterChanged={e => mapCenterChanged && mapCenterChanged(e)}
      onDragstart={e => onDragStart && onDragStart(e)}
      onDragend={e => onDragEnd && onDragEnd(e)}
      onZoomChanged={e => onZoomChanged && onZoomChanged(e)}
    >
      {children}
    </Map>
  </APIProvider>
)

export default MapWrapper
